<template>
  <back-top>
    <div class="container2">
      <!-- 展商信息 -->
      <div class="row1">
        <div class="exhibitor">
          <div class="title">
            <div class="name">
              <div class="name1">{{ baseInfo.name }}</div>
              <div class="name2">{{ baseInfo.named }}</div>
            </div>
            <button @click="editExhi">{{ $t("home.editInfo") }}</button>
          </div>

          <div class="content">
            <div class="info">
              <span class="label">{{ $t("home.company") }}</span
              ><span class="value">{{ baseInfo.company }}</span>
            </div>

            <div class="info">
              <span class="label">{{ $t("common.phone") }}</span
              ><span class="value">{{ baseInfo.registAccount }}</span>
            </div>

            <div class="info">
              <span class="label">{{ $t("home.address") }}</span>
              <span class="value">{{ baseInfo.column17 }}</span>
            </div>

            <div class="info">
              <span class="label">{{ $t("common.email") }}</span>
              <span class="value">{{ baseInfo.email }}</span>
            </div>
          </div>
        </div>
      </div>
      <!-- 数据统计 -->
      <div class="statistical">
        <h3>{{ $t("home.statistics") }}</h3>
        <div class="shujv">
          <div class="box1">
            {{ $t("Favorites.collentExhibitors") }}
            <h2>{{ number.zs }}</h2>
          </div>
          <div class="box1">
            {{ $t("Favorites.collentExhibits") }}
            <h2>{{ number.zp }}</h2>
          </div>

          <div class="box1">
            {{ $t("Favorites.collentLive") }}
            <h2>{{ number.zb }}</h2>
          </div>
          <div class="box1 lastBox1">
            {{ $t("Favorites.collentActive") }}
            <h2>{{ number.hd }}</h2>
          </div>
        </div>
      </div>

      <div>
        <Tab :title="$t('common.recommend.exhibition')" tab="1"></Tab>
        <Exhibition :exfalg="false"></Exhibition>
      </div>

      <div>
        <Tab :title="$t('common.recommend.exhibits')" tab="2"></Tab>
        <Product :exfalg="false"></Product>
      </div>

      <div>
        <Tab :title="$t('common.recommend.live')" tab="3"></Tab>
        <Live></Live>
      </div>

      <div>
        <Tab :title="$t('common.recommend.activity')" tab="4"></Tab>
        <Activity></Activity>
      </div>

      <div class="alert_mess" v-show="visible">
        <img class="close" @click="close" src="../../static/close.png" />
        <div class="qrcode">
          <img :src="baseUrl + livePhoto" alt="" />
          <div class="txt">{{ $t("common.qrCode") }}</div>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </back-top>
</template>

<script>
import Footer from "../components/Footer.vue";
import Exhibition from "../recommend/components/exhibition.vue"; //推荐展商
import Product from "../recommend/components/product.vue"; //推荐产品
import Live from "../recommend/components/live.vue"; //推荐直播
import Activity from "../recommend/components/activity.vue"; //推荐活动
import Tab from "../recommend/components/tab.vue";
import {
  forMat,
  backProductDetail,
  backActivityDetail,
  backLiveDetail,
  backExhibitionList,
} from "../../../utils/common.js";

import { getInfo } from "../../../api/personInfo.js";

import {
  getProductsLists,
  getLiveLists,
  getActivityLists,
} from "../../../api/recommend.js";

import { getLists } from "../../../api/message.js";

import {
  getExLists,
  getColProductsLists,
  getColLiveLists,
  getColActivityLists,
} from "../../../api/collection.js";

export default {
  components: {
    Exhibition, //推荐展商
    Product,
    Live,
    Activity,
    Tab, //导航栏
    Footer,
  },
  data() {
    return {
      baseUrl: forMat(),
      number: {
        zs: "",
        zp: "",
        zb: "",
        hd: "",
      },
      baseInfo: {},
      productLists: [],
      liveLists: [],
      messageLists: [],
      activityLists: [],
      screenWidth: "",
      productDetailUrl: backProductDetail(),
      activityDetailUrl: backActivityDetail(),
      liveDetailUrl: backLiveDetail(),
      exhibitonUrl: backExhibitionList(),
      visible: false,
      livePhoto: "",
    };
  },
  created() {
    this.initListData();
    this.initColData();
  },
  methods: {
    consultzs() {
      // 跳转至线上展会列表
      window.location.href = this.exhibitonUrl;
    },
    close() {
      this.visible = false;
    },
    goLiveDetail(item) {
      switch (item.videoType) {
        case "1":
          // 视频 跳详情页
          window.location.href = this.liveDetailUrl + "?userId=" + item.id;
          break;

        case "2":
          // 直播外链 打开新窗口
          window.open(item.videoAddress);
          break;

        case "3":
          //  二维码 弹窗
          this.visible = true;
          this.livePhoto = item.videoAddress;
          break;
      }
    },
    goActivityDetail(item) {
      window.location.href = this.activityDetailUrl + "?id=" + item.id;
    },
    goProductDetail(item) {
      window.location.href = this.productDetailUrl + "?id=" + item.id;
    },
    initListData() {
      this.getExhibitor();
      this.getProducts();
      this.getLives();
      this.getMessage();
      this.getActivitys();
    },

    //调用此函数
    initColData() {
      this.getColzs();
      this.getColzp();
      this.getColzb();
      this.getColhd();
    },

    viewActivity() {
      this.$router.push({ name: "recommendInfo", query: { tab: "4" } });
    },
    viewLive() {
      this.$router.push({ name: "recommendInfo", query: { tab: "3" } });
    },
    viewMessage() {
      this.$router.push("/backIndex/myMessage");
    },
    viewProduct() {
      this.$router.push({ name: "recommendInfo", query: { tab: "2" } });
    },

    editExhi() {
      this.$router.push({ name: "personInfo", query: { positionId: "first" } });
    },
    async getColzs() {
      const params = {
        keyword: "",
      };
      try {
        const { data } = await getExLists(params);
        if (data.code === 200) {
          this.number.zs = data.data.length;
        }
      } catch (err) {
        console.log(err.msg);
      }
    },
    async getColzp() {
      const params = {
        keyword: "",
      };
      try {
        const { data } = await getColProductsLists(params);
        if (data.code === 200) {
          this.number.zp = data.data.length;
        }
      } catch (err) {
        console.log(err.msg);
      }
    },
    async getColzb() {
      try {
        const { data } = await getColLiveLists();
        if (data.code === 200) {
          this.number.zb = data.data.length;
        }
      } catch (err) {
        console.log(err.msg);
      }
    },
    async getColhd() {
      try {
        const { data } = await getColActivityLists();
        if (data.code === 200) {
          this.number.hd = data.data.length;
        }
      } catch (err) {
        console.log(err.msg);
      }
    },
    async getExhibitor() {
      try {
        const { data } = await getInfo();
        if (data.code === 200) {
          this.baseInfo = data.data;
        }
      } catch (err) {
        console.log(err.msg);
      }
    },
    async getProducts() {
      const params = {
        value: {
          exhibitsType: [],
          keyword: "",
        },
      };
      try {
        const { data } = await getProductsLists(params);
        if (data.code === 200) {
          this.productLists = data.data.list.slice(0, 5);
        }
      } catch (err) {
        console.log(err.msg);
      }
    },
    async getLives() {
      try {
        const { data } = await getLiveLists();
        if (data.code === 200) {
          this.liveLists = data.data.list.slice(0, 3);
        }
      } catch (err) {
        console.log(err.msg);
      }
    },
    async getMessage() {
      try {
        const { data } = await getLists();
        if (data.code === 200) {
          this.messageLists = data.data.slice(0, 3);
        }
      } catch (err) {
        console.log(err.msg);
      }
    },
    async getActivitys() {
      try {
        const { data } = await getActivityLists();
        if (data.code === 200) {
          this.activityLists = data.data.list.slice(0, 5);
        }
      } catch (err) {
        console.log(err.msg);
      }
    },
  },

  mounted() {
    const that = this;
    window.addEventListener("setItemEvent", function(e) {
      if (e.key == "collentChange") {
        that.initColData();
      }
    });
  },
};
</script>
<style lang="scss" scoped>
.container2 {
  padding: 60px 10px 0px 10px;
  box-sizing: border-box;
  background: #f0f2f5;
  .row1 {
    .exhibitor {
      width: 100%;
      margin-right: 26px;
      box-sizing: border-box;
      padding: 0px 0px 10px 0;
      .title {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 17px 15px 23px 26px;
        background: white;
        .name {
          display: flex;
          justify-content: space-between;
          align-items: flex-end;
          background: white;
          .name1 {
            font-size: 18px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 600;
            color: #333333;
            line-height: 25px;
          }
          .name2 {
            padding-left: 5px;
            font-size: 12px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #333333;
            line-height: 17px;
          }
        }
        button {
          display: block;
          width: 88px;
          height: 32px;
          border: none;
          background: #006fb8;
          color: white;
          border-radius: 4px;
          cursor: pointer;
        }
      }
      .content {
        background: white;
        box-sizing: border-box;
        width: 100%;
        padding-bottom: 40px;
        .info {
          padding-top: 10px;
          padding-left: 15px;
          box-sizing: border-box;
          .label {
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #333333;
            line-height: 20px;
          }
          .value {
            font-size: 14px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 600;
            color: #333333;
            line-height: 20px;
          }
        }
      }
    }
  }
  .statistical {
    width: 100%;
    box-sizing: border-box;
    background: white;
    h3 {
      box-sizing: border-box;
      padding: 18px 0 11px 26px;
    }
    .shujv {
      display: flex;
      padding-bottom: 22px;
      margin: 8px 20px 0px 20px;
      justify-content: space-around;

      .box1 {
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
        line-height: 17px;
        text-align: center;
        border-right: 1px solid #e9e9e9;
        flex: 1;
        h2 {
          margin-top: 17px;
          font-size: 26px;
          font-family: HelveticaNeue-Medium, HelveticaNeue;
          font-weight: 500;
          color: #333333;
          line-height: 33px;
        }
      }
      .lastBox1 {
        border-right: none;
      }
    }
  }
  .alert_mess {
    width: 200px;
    height: 210px;
    box-sizing: border-box;
    text-align: center;
    box-shadow: 0px 0px 51px 0px #c1c6cb;
    background: white;
    position: fixed;
    top: 0px;
    left: 0px;
    right: 0px;
    bottom: 0px;
    margin: auto;
    z-index: 99;
    display: flex;
    justify-content: center;
    align-items: center;
    .close {
      float: right;
      width: 15;
      height: 15px;
      position: absolute;
      right: 15px;
      top: 15px;
    }
    .qrcode {
      width: 140px;
      height: 120px;
      position: relative;
      top: 10px;
      img {
        width: 100%;
        height: 100%;
        display: block;
      }
    }
    .txt {
      font-size: 10px;
      font-family: Microsoft YaHei;
      padding-top: 10px;
      font-weight: 400;
      color: #333333;
    }
  }
  .nodata {
    text-align: center;
    margin: 0 auto;
    .button {
      width: 88px;
      height: 32px;
      background: #006fb8;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #ffffff;
      line-height: 32px;
      text-align: center;
      margin: 20px auto;
      border-radius: 4px;
      cursor: pointer;
    }
  }
}
</style>
